import Vuex from 'vuex'
import Vue from 'vue'
import user from './modules/user'

import stores from './modules/store'
import query from './modules/query'
import Inspection from './modules/inspection'
import Database from './modules/database'
import StoreChange from './modules/storeChange'
import ListSave from './modules/listSave'
import RadioSave from './modules/radioSave'
import Page1 from './modules/page1'
import Page2 from './modules/page2'
import Page3 from './modules/page3'
import Radio2 from './modules/radio2'
import data from './modules/data'
import clientTab from './modules/clientTab'
import mainCustomer from './modules/mainCustomer'
import salesData from './modules/salesData'
import parameters from './modules/parameters'

Vue.use(Vuex)
let store = new Vuex.Store({
    modules: {
        user,
        stores,
        Inspection,
        Database,
        StoreChange,
        ListSave,
        RadioSave,
        Page1,
        Page2,
        Page3,
        Radio2,
        data,
        clientTab,
        mainCustomer,
        query,
        salesData,
        parameters
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js